<!-- START: forms/internal assets -->
<div class="stockprice">

<!-- ═══════════════════════════════════════════════════════════════════════════
     NEW DESIGN — Financial Data Extractor API  (useFinancialExtractAPI = true)
     ═══════════════════════════════════════════════════════════════════════════ -->
<section *ngIf="useNewApi" class="fmp-share-card">
  <button aria-label="Close" class="fmp-close-btn" data-dismiss="modal" type="button">
    <span aria-hidden="true">×</span>
  </button>

  <!-- ── Loading ── -->
  <div *ngIf="isLoadingFmpShare" class="fmp-state-box">
    <i class="fa fa-circle-o-notch fa-spin fmp-state-icon"></i>
    <p class="fmp-state-text">Loading share information…</p>
  </div>

  <!-- ── Error ── -->
  <div *ngIf="!isLoadingFmpShare && fmpShareError" class="fmp-state-box fmp-state-error">
    <i class="fa fa-exclamation-triangle fmp-state-icon"></i>
    <p class="fmp-state-text">{{ fmpShareError }}</p>
    <button class="btn btn-sm btn-outline-danger mt-2" (click)="loadFmpShareInfo()">
      <i class="fa fa-refresh"></i>&nbsp;Retry
    </button>
  </div>

  <!-- ── Data ── -->
  <ng-container *ngIf="!isLoadingFmpShare && !fmpShareError && fmpShareData">

    <!-- ── HEADER ── -->
    <div class="fmp-header">
      <div class="fmp-header-left">
        <h2 class="fmp-company-name">{{ fmpShareData.company_name || fmpShareData.symbol }}</h2>
        <div class="fmp-header-badges">
          <span class="fmp-badge fmp-badge-symbol">{{ fmpShareData.symbol }}</span>
          <span class="fmp-badge fmp-badge-exchange">{{ fmpShareData.exchange }}</span>
          <!-- <span class="fmp-badge fmp-badge-source">FMP</span> -->
        </div>
      </div>
      <div class="fmp-header-right">
        <button class="fmp-refresh-btn" (click)="loadFmpShareInfo()" title="Refresh data">
          <i class="fa fa-refresh"></i>
        </button>
      </div>
    </div>

    <!-- ── PRICE HERO ── -->
    <div class="fmp-price-hero">
      <div class="fmp-current-price">
        ₹{{ fmpShareData.current_price | number:'1.2-2' }}
        <span class="fmp-currency-note">INR</span>
      </div>
      <div class="fmp-price-change" [ngClass]="priceChangeClass(fmpShareData.price_change)">
        <i class="fa" [ngClass]="{'fa-caret-up': fmpShareData.price_change > 0, 'fa-caret-down': fmpShareData.price_change < 0, 'fa-minus': fmpShareData.price_change === 0}"></i>
        {{ signedNumber(fmpShareData.price_change) }}
        ({{ (fmpShareData.price_change_percent | number:'1.2-4') }}%)
      </div>
      <div class="fmp-prev-close">
        Prev. Close &nbsp;<strong>₹{{ fmpShareData.previous_close | number:'1.2-2' }}</strong>
      </div>
    </div>

    <!-- ── PRICE RANGES (NSE / BSE) ── -->
    <div class="fmp-ranges-row" *ngIf="fmpShareData.price_ranges">
      <!-- NSE -->
      <div class="fmp-range-card" *ngIf="fmpShareData.price_ranges.nse">
        <div class="fmp-range-exchange">NSE</div>
        <div class="fmp-range-grid">
          <div class="fmp-range-item">
            <span class="fmp-range-label">Day Low</span>
            <span class="fmp-range-val fmp-negative">₹{{ fmpShareData.price_ranges.nse.day_low | number:'1.2-2' }}</span>
          </div>
          <div class="fmp-range-item">
            <span class="fmp-range-label">Day High</span>
            <span class="fmp-range-val fmp-positive">₹{{ fmpShareData.price_ranges.nse.day_high | number:'1.2-2' }}</span>
          </div>
          <div class="fmp-range-item">
            <span class="fmp-range-label">52W Low</span>
            <span class="fmp-range-val fmp-negative">₹{{ fmpShareData.price_ranges.nse['52_week_low'] | number:'1.2-2' }}</span>
          </div>
          <div class="fmp-range-item">
            <span class="fmp-range-label">52W High</span>
            <span class="fmp-range-val fmp-positive">₹{{ fmpShareData.price_ranges.nse['52_week_high'] | number:'1.2-2' }}</span>
          </div>
        </div>
        <!-- 52-week range bar -->
        <div class="fmp-range-bar-wrap" *ngIf="fmpShareData.price_ranges.nse['52_week_low'] && fmpShareData.price_ranges.nse['52_week_high']">
          <div class="fmp-range-bar">
            <div class="fmp-range-fill"
              [style.left.%]="((fmpShareData.current_price - fmpShareData.price_ranges.nse['52_week_low']) / (fmpShareData.price_ranges.nse['52_week_high'] - fmpShareData.price_ranges.nse['52_week_low'])) * 100 - 1"
              [style.width.%]="2">
            </div>
          </div>
          <div class="fmp-range-bar-labels">
            <span>52W Low</span><span>52W High</span>
          </div>
        </div>
      </div>

      <!-- BSE -->
      <div class="fmp-range-card" *ngIf="fmpShareData.price_ranges.bse">
        <div class="fmp-range-exchange">BSE</div>
        <div class="fmp-range-grid">
          <div class="fmp-range-item">
            <span class="fmp-range-label">Day Low</span>
            <span class="fmp-range-val fmp-negative">₹{{ fmpShareData.price_ranges.bse.day_low | number:'1.2-2' }}</span>
          </div>
          <div class="fmp-range-item">
            <span class="fmp-range-label">Day High</span>
            <span class="fmp-range-val fmp-positive">₹{{ fmpShareData.price_ranges.bse.day_high | number:'1.2-2' }}</span>
          </div>
          <div class="fmp-range-item">
            <span class="fmp-range-label">52W Low</span>
            <span class="fmp-range-val fmp-negative">₹{{ fmpShareData.price_ranges.bse['52_week_low'] | number:'1.2-2' }}</span>
          </div>
          <div class="fmp-range-item">
            <span class="fmp-range-label">52W High</span>
            <span class="fmp-range-val fmp-positive">₹{{ fmpShareData.price_ranges.bse['52_week_high'] | number:'1.2-2' }}</span>
          </div>
        </div>
        <div class="fmp-range-bar-wrap" *ngIf="fmpShareData.price_ranges.bse['52_week_low'] && fmpShareData.price_ranges.bse['52_week_high']">
          <div class="fmp-range-bar">
            <div class="fmp-range-fill"
              [style.left.%]="((fmpShareData.current_price - fmpShareData.price_ranges.bse['52_week_low']) / (fmpShareData.price_ranges.bse['52_week_high'] - fmpShareData.price_ranges.bse['52_week_low'])) * 100 - 1"
              [style.width.%]="2">
            </div>
          </div>
          <div class="fmp-range-bar-labels">
            <span>52W Low</span><span>52W High</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ── METRICS GRID ── -->
    <div class="fmp-metrics-section">
      <h6 class="fmp-section-title">Key Metrics</h6>
      <div class="fmp-metrics-grid">

        <!-- Market Cap -->
        <div class="fmp-metric-card" *ngIf="fmpShareData.market_cap">
          <div class="fmp-metric-icon fmp-icon-blue"><i class="fa fa-bar-chart"></i></div>
          <div class="fmp-metric-body">
            <div class="fmp-metric-label">Market Cap (Consolidated)</div>
            <div class="fmp-metric-value">{{ formatMarketCap(fmpShareData.market_cap.consolidated) }}</div>
          </div>
        </div>
        <div class="fmp-metric-card" *ngIf="fmpShareData.market_cap && fmpShareData.market_cap.standalone !== fmpShareData.market_cap.consolidated">
          <div class="fmp-metric-icon fmp-icon-blue"><i class="fa fa-bar-chart"></i></div>
          <div class="fmp-metric-body">
            <div class="fmp-metric-label">Market Cap (Standalone)</div>
            <div class="fmp-metric-value">{{ formatMarketCap(fmpShareData.market_cap.standalone) }}</div>
          </div>
        </div>

        <!-- Valuation -->
        <div class="fmp-metric-card" *ngIf="fmpShareData.valuation">
          <div class="fmp-metric-icon fmp-icon-purple"><i class="fa fa-book"></i></div>
          <div class="fmp-metric-body">
            <div class="fmp-metric-label">Book Value / Share</div>
            <div class="fmp-metric-value">₹{{ fmpShareData.valuation.book_value_per_share | number:'1.2-2' }}</div>
          </div>
        </div>
        <div class="fmp-metric-card" *ngIf="fmpShareData.valuation && fmpShareData.valuation.pe_ratio != null">
          <div class="fmp-metric-icon fmp-icon-teal"><i class="fa fa-percent"></i></div>
          <div class="fmp-metric-body">
            <div class="fmp-metric-label">P/E Ratio</div>
            <div class="fmp-metric-value">{{ fmpShareData.valuation.pe_ratio | number:'1.2-2' }}</div>
          </div>
        </div>
        <div class="fmp-metric-card" *ngIf="fmpShareData.valuation && fmpShareData.valuation.pb_ratio != null">
          <div class="fmp-metric-icon fmp-icon-teal"><i class="fa fa-percent"></i></div>
          <div class="fmp-metric-body">
            <div class="fmp-metric-label">P/B Ratio</div>
            <div class="fmp-metric-value">{{ fmpShareData.valuation.pb_ratio | number:'1.2-2' }}</div>
          </div>
        </div>
        <div class="fmp-metric-card" *ngIf="fmpShareData.valuation && fmpShareData.valuation.ps_ratio != null">
          <div class="fmp-metric-icon fmp-icon-teal"><i class="fa fa-percent"></i></div>
          <div class="fmp-metric-body">
            <div class="fmp-metric-label">P/S Ratio</div>
            <div class="fmp-metric-value">{{ fmpShareData.valuation.ps_ratio | number:'1.2-2' }}</div>
          </div>
        </div>

        <!-- Trading -->
        <div class="fmp-metric-card" *ngIf="fmpShareData.trading">
          <div class="fmp-metric-icon fmp-icon-green"><i class="fa fa-exchange"></i></div>
          <div class="fmp-metric-body">
            <div class="fmp-metric-label">Volume</div>
            <div class="fmp-metric-value">{{ fmpShareData.trading.volume | number }}</div>
          </div>
        </div>
        <div class="fmp-metric-card" *ngIf="fmpShareData.trading && fmpShareData.trading.avg_volume">
          <div class="fmp-metric-icon fmp-icon-green"><i class="fa fa-line-chart"></i></div>
          <div class="fmp-metric-body">
            <div class="fmp-metric-label">Avg. Volume</div>
            <div class="fmp-metric-value">{{ fmpShareData.trading.avg_volume | number }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- ── FOOTER ── -->
    <div class="fmp-footer">
      <span class="fmp-footer-ts" *ngIf="fmpShareData.timestamp">
        <i class="fa fa-clock-o"></i>&nbsp;
        Last updated: {{ fmpShareData.timestamp | date:'dd MMM yyyy, h:mm a' }}
      </span>
      <!-- <span class="fmp-footer-source">Source: Financial Market Platform</span> -->
    </div>

  </ng-container>
</section>

<!-- ═══════════════════════════════════════════════════════════════════════════
     LEGACY DESIGN — Robocs API  (useFinancialExtractAPI = false)
     ═══════════════════════════════════════════════════════════════════════════ -->
<ng-container *ngIf="!useNewApi">
  <section class="card">
      <button _ngcontent-c3="" aria-label="Close" class="close" data-dismiss="modal" type="button">
          <span _ngcontent-c3="" aria-hidden="true">×</span>
      </button>
      <div class="card-header">
          <div class="row">
              <!-- BSE -->
              <div class="col-lg-4 col-md-6">
                  <div class="row1">
                      <div class="row" *ngIf="!isBSEDataFound" style="text-transform: initial;">
                          <label class="col-lg-12">This Company is not listed in BSE</label>
                      </div>
                      <div class="row" *ngIf="isBSEDataFound">
                          <div class="col-md-12">
                              <span style="color: #808282;">CLOSING PRICE (BSE)</span>
                              <h3 class="mb-0  mt-1">
                                  <span class="share-price">{{bseStockClosingPrice | number : '1.2-2'}}</span>
                                  <span *ngIf="bseDifferenceInStockPrice == 0" style="color: #a5a7ab; font-size: 18px;" class="ml-3">                    
                                  <i class="fa fa-caret-left"></i>
                                  <i class="fa fa-caret-right mr-1"></i>
                                  <span>{{bseDifferenceInStockPrice | number : '1.2-2'}} ({{bsePercentageChange | number : '1.2-2'}}%)</span>
                                  </span>
                                  <span *ngIf="bseDifferenceInStockPrice > 0" style="font-size: 18px;" class="ml-3">
                                  <i class="fa fa-caret-up mr-1"></i>
                                  <span>{{bseDifferenceInStockPrice | number : '1.2-2'}} ({{bsePercentageChange | number : '1.2-2'}}%)</span>
                                  </span>
                                  <span *ngIf="bseDifferenceInStockPrice < 0" style="font-size: 18px;" class="ml-3">
                                  <i class="fa fa-caret-down mr-1"></i>
                                  <span>{{bseDifferenceInStockPrice | number : '1.2-2'}} ({{bsePercentageChange | number : '1.2-2'}}%)</span>
                                  </span>
                              </h3>
                          </div>
                          <div class="col-md-12 share-detail-uppercase">
                              <div style="padding: 5px 0px;">
                                  <div class="row">
                                      <div class="col-sm-6">
                                          <div><span class="low-high-text">Previous</span> <span class="red-text-low">Low</span>                                                <span class="devider-minus">/</span> <span class="green-text-low">High</span></div>
                                      </div>
                                      <div class="col-sm-6">
                                          <div>
                                              <span class="red-text-low">{{bsePreviousSPLow | number : '1.2-2'}}</span>
                                              <span class="devider-minus">/</span>
                                              <span class="green-text-low">{{bsePreviousSPHigh | number : '1.2-2'}}</span></div>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="col-sm-6">
                                          <div><span class="low-high-text">52 Week</span> <span class="red-text-low">Low</span>                                                <span class="devider-minus">/</span> <span class="green-text-low">High</span></div>
                                      </div>
                                      <div class="col-sm-6">
                                          <div style="margin-bottom: 0px;">
                                              <span class="red-text-low">{{bseWeek52SPLow | number : '1.2-2'}}</span>
                                              <span class="devider-minus">/</span>
                                              <span class="green-text-low">{{bseWeek52SPHigh | number : '1.2-2'}}</span></div>
                                      </div>
                                  </div>
                              </div>

                          </div>
                      </div>
                  </div>
              </div>
              <!-- NSE -->
              <div class="col-lg-4 col-md-6">
                  <div class="row1">
                      <div class="row" *ngIf="!isNSEDataFound" style="text-transform: initial;">
                          <label>This Company is not listed in NSE</label>
                      </div>
                      <div class="row" *ngIf="isNSEDataFound">
                          <div class="col-md-12">
                              <span style="color: #808282;">CLOSING PRICE (NSE)</span>
                              <h3 class="mb-0  mt-1">
                                  <span class="share-price">{{nseStockClosingPrice | number : '1.2-2'}}</span>
                                  <span *ngIf="nseDifferenceInStockPrice == 0" style="color: #a5a7ab; font-size: 18px;" class="ml-3">                    
                                          <i class="fa fa-caret-left"></i>
                                          <i class="fa fa-caret-right mr-1"></i>
                                          <span>{{nseDifferenceInStockPrice | number : '1.2-2'}} ({{nsePercentageChange | number : '1.2-2'}}%)</span>
                                  </span>
                                  <span *ngIf="nseDifferenceInStockPrice > 0" style="font-size: 18px;" class="ml-3">
                                          <i class="fa fa-caret-up mr-1"></i>
                                          <span>{{nseDifferenceInStockPrice | number : '1.2-2'}} ({{nsePercentageChange | number : '1.2-2'}}%)</span>
                                  </span>
                                  <span *ngIf="nseDifferenceInStockPrice < 0" style="font-size: 18px;" class="ml-3">
                                          <i class="fa fa-caret-down mr-1"></i>
                                          <span>{{nseDifferenceInStockPrice | number : '1.2-2'}} ({{nsePercentageChange | number : '1.2-2'}}%)</span>
                                  </span>
                              </h3>
                          </div>
                          <div class="col-md-12 share-detail-uppercase">
                              <div style="padding: 5px 0px;">
                                  <div class="row">
                                      <div class="col-sm-6">
                                          <div><span class="low-high-text">Previous</span> <span class="red-text-low">Low</span>                                                <span class="devider-minus">/</span> <span class="green-text-low">High</span></div>
                                      </div>
                                      <div class="col-sm-6">
                                          <div>
                                              <span class="red-text-low">{{nsePreviousSPLow | number : '1.2-2'}}</span>
                                              <span class="devider-minus">/</span>
                                              <span class="green-text-low">{{nsePreviousSPHigh | number : '1.2-2'}}</span></div>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="col-sm-6">
                                          <div><span class="low-high-text">52 Week</span> <span class="red-text-low">Low</span>                                                <span class="devider-minus">/</span> <span class="green-text-low">High</span></div>
                                      </div>
                                      <div class="col-sm-6">
                                          <div style="margin-bottom: 0px;">
                                              <span class="red-text-low">{{nseWeek52SPLow | number : '1.2-2'}}</span>
                                              <span class="devider-minus">/</span>
                                              <span class="green-text-low">{{nseWeek52SPHigh | number : '1.2-2'}}</span></div>
                                      </div>
                                  </div>
                              </div>

                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-lg-4"> </div>
          </div>
      </div>

      <div class="nav-tabs-horizontal">
          <ul class="nav nav-tabs inverse" role="tablist" style="background: #37669e;">
              <li class="nav-item">
                  <a class="nav-link active" data-target="#marketCap" data-toggle="tab" href="javascript: void(0);" role="tab" aria-expanded="true"
                      (click)="tabToogle('MCAP')">Market Capitalization</a>
              </li>
              <li class="nav-item">
                  <a class="nav-link" data-target="#priceEarning" data-toggle="tab" href="javascript: void(0);" role="tab" aria-expanded="false"
                      (click)="tabToogle('PE')">PE</a>
              </li>
              <li class="nav-item">
                  <a class="nav-link" data-target="#bookValue" data-toggle="tab" href="javascript: void(0);" role="tab" aria-expanded="false"
                      (click)="tabToogle('BookValue')">Book Value (Per Share)</a>
              </li>
          </ul>
          <div class="tab-content ">
              <div class="tab-pane active" id="marketCap" role="tabcard" aria-expanded="true">
                  <div class="row sub-tabs-section">
                      <div id="standaloneMCAPSection" class="tabs-2 widget_sp pull-left" (click)="getStandaloneMCAPData()">
                          <span class="widget_sp_title">Standalone</span>
                      </div>
                      <div id="consolidatedMCAPSection" class="tabs-2 widget_sp" (click)="getConsolidatedMCAPData()">
                          <span class="widget_sp_title">Consolidated</span>
                      </div>
                  </div>
                  <div class="card-block watermark" style="min-height: 300px;">
                      <div id="standaloneMCAPDataSection" style="display: none;">
                          <div id="standaloneMCapContainer" class="m-auto" width="100%" style="padding: 40px;">
                              <chart type="StockChart" [options]="standaloneMCapChart"></chart>
                          </div>
                      </div>
                      <div id="consolidatedMCAPDataSection" style="display: none;">
                          <div id="consolidatedMCapContainer" class="m-auto" width="100%" style="padding: 40px;">
                              <chart type="StockChart" [options]="consolidatedMCapChart"></chart>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="tab-pane" id="priceEarning" role="tabcard" aria-expanded="false">
                  <div class="row sub-tabs-section">
                      <div id="standalonePESection" class="tabs-2 widget_sp pull-left" (click)="getStandalonePEData()">
                          <span class="widget_sp_title">Standalone</span>
                      </div>
                      <div id="consolidatedPESection" class=" tabs-2 widget_sp" (click)="getConsolidatedPEData()">
                          <span class="widget_sp_title">Consolidated</span>
                      </div>
                  </div>
                  <div class="card-block watermark" style="min-height: 300px;">
                      <div id="standalonePEDataSection" style="display: none;">
                          <div id="standalonePEContainer" class="m-auto" width="100%" style="padding: 40px;">
                              <chart type="StockChart" [options]="standalonePEChart"></chart>
                          </div>
                      </div>
                      <div id="consolidatedPEDataSection" style="display: none;">
                          <div id="consolidatedPEContainer" class="m-auto" width="100%" style="padding: 40px;">
                              <chart type="StockChart" [options]="consolidatedPEChart"></chart>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="tab-pane" id="bookValue" role="tabcard" aria-expanded="false">
                  <div class="row sub-tabs-section">
                      <div id="standaloneBookValueSection" class="tabs-2 widget_sp pull-left" (click)="getStandaloneBookValueData()">
                          <span class="widget_sp_title">Standalone</span>
                      </div>
                      <div id="consolidatedBookValueSection" class="cat__core__widg tabs-2 widget_sp" (click)="getConsolidatedBookValueData()">
                          <span class="widget_sp_title">Consolidated</span>
                      </div>
                  </div>
                  <div class="card-block watermark" style="min-height: 300px;">
                      <div id="standaloneBookValueDataSection" style="display: none;">
                          <div id="standaloneBookValueContainer" class="m-auto" width="100%" style="padding: 40px;">
                              <chart type="StockChart" [options]="standaloneBookValueChart"></chart>
                          </div>
                      </div>
                      <div id="consolidatedBookValueDataSection" style="display: none;">
                          <div id="consolidatedBookValueContainer" class="m-auto" width="100%" style="padding: 40px;">
                              <chart type="StockChart" [options]="consolidatedBookValueChart"></chart>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </section>
</ng-container><!-- end legacy design -->

</div>
<!-- END: forms/internal assets -->